import { memo } from 'react';
import { Box } from '@chakra-ui/react';
/**
 * @typedef {Omit<import('@chakra-ui/react').BoxProps, 'position'>  & {
 *   position: 'top' | 'bottom'
 * }} BlockShadowProps
 */

/** @param {BlockShadowProps} props */
const BlockShadow = ({ position, ...props }) => {
  const isTopShadow = position === 'top';

  return (
    <Box
      w="full"
      h={{ mobile: '50px', tablet: '100px', laptop: '150px' }}
      bg={
        isTopShadow
          ? 'linear-gradient(0deg, rgba(14, 21, 28, 0) 0%, #0E151C 100%)'
          : 'linear-gradient(0deg, #0E151C 0%, rgba(14, 21, 28, 0) 100%)'
      }
      pos="absolute"
      top={isTopShadow ? '0' : undefined}
      bottom={isTopShadow ? undefined : '0'}
      left="0"
      {...props}
    />
  );
};

export default memo(BlockShadow);
